import React from "react";
import * as Styled from "./styles";
import { useClinicalBudget } from "shared/providers/ClinicalBudget";
import { IoClose } from "react-icons/io5";

const BudgetObsModal: React.FC = () => {
  const {
    showObsModal,
    setShowObsModal,
    selectedProc,
    selectedArea,
    selectedCategoria,
    selectedValor,
    selectedCatprocId,
    addItem,
    setSelectedProc,
    setSelectedCategoria,
    setSelectedGrupo,
  } = useClinicalBudget();

  const [obs, setObs] = React.useState('');

  React.useEffect(() => {
    if (showObsModal) setObs('');
  }, [showObsModal]);

  if (!showObsModal || !selectedProc) return null;

  const valor = selectedValor || selectedProc.valor;
  const grupoNome = selectedCategoria?.nome ?? '';

  const handleAdd = (obsText: string) => {
    addItem({
      procId: selectedProc.id,
      procNome: selectedProc.nome,
      area: selectedArea,
      elemento: 0,
      valor: valor,
      grupoId: 0,
      grupoNome: grupoNome,
      qtde: 1,
      faces: '',
      catprocId: selectedCatprocId || 0,
      gpitemId: 0,
      obsPersonalizado: obsText,
    });

    setShowObsModal(false);
    setSelectedProc(null);
    setSelectedCategoria(null);
    setSelectedGrupo(null);
  };

  const handleClose = () => {
    setShowObsModal(false);
    setSelectedProc(null);
    setSelectedCategoria(null);
    setSelectedGrupo(null);
  };

  return (
    <Styled.ModalOverlay onClick={handleClose}>
      <Styled.ModalContent onClick={e => e.stopPropagation()}>
        <Styled.ModalHeader>
          <Styled.CloseButton onClick={handleClose}>
            <IoClose size={24} />
          </Styled.CloseButton>
          <h3>Observação do Procedimento</h3>
          <p>{selectedProc.nome}</p>
        </Styled.ModalHeader>

        <Styled.ModalBody>
          <Styled.InfoText>
            Deseja adicionar uma observação personalizada?
          </Styled.InfoText>
          <Styled.TextArea
            value={obs}
            onChange={e => setObs(e.target.value)}
            placeholder="Ex: Região específica, detalhes do tratamento..."
            maxLength={500}
          />
        </Styled.ModalBody>

        <Styled.ModalFooter>
          <Styled.FooterButton variant="secondary" onClick={() => handleAdd('')}>
            Pular
          </Styled.FooterButton>
          <Styled.FooterButton variant="primary" onClick={() => handleAdd(obs)}>
            Adicionar
          </Styled.FooterButton>
        </Styled.ModalFooter>
      </Styled.ModalContent>
    </Styled.ModalOverlay>
  );
};

export { BudgetObsModal };
